export default "__VITE_ASSET__AYMIv_zZ__"